import { render, staticRenderFns } from "./TheNotifc.vue?vue&type=template&id=e60edb62&"
import script from "./TheNotifc.vue?vue&type=script&setup=true&lang=js&"
export * from "./TheNotifc.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TheNotifc.vue?vue&type=style&index=0&id=e60edb62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports